import React from 'react';
import { NavLink } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <nav className="footer-nav">
        <NavLink to="/" className={({ isActive }) => isActive ? "footer-link active" : "footer-link"}>
          <img src="/icons/icon-gift.png" alt="Главная" className="footer-icon icon-gift" />
          <span className="footer-text">Главная</span>
        </NavLink>
        <NavLink to="/rating" className={({ isActive }) => isActive ? "footer-link active" : "footer-link"}>
          <img src="/icons/icon-rating.png" alt="Рейтинг" className="footer-icon icon-rating" />
          <span className="footer-text">Рейтинг</span>
        </NavLink>
        <NavLink to="/profile" className={({ isActive }) => isActive ? "footer-link active" : "footer-link"}>
          <img src="/icons/icon-profile.png" alt="Профиль" className="footer-icon icon-profile" />
          <span className="footer-text">Профиль</span>
        </NavLink>
      </nav>
    </footer>
  );
};

export default Footer; 